import dayjs from 'dayjs';

import { TiendaPerfectaVisitHistoryStop } from 'models/TiendaPerfecta';

import { VisitSelection } from './selection';

export interface SelectionDescription {
  kind: 'day' | 'route' | 'van' | 'zone';
  /** Nombre legible; el texto del tipo ("Camioneta") lo pone la vista. */
  label: string;
}

const formatDate = (date: string): string =>
  dayjs(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

/** El texto del chip de seleccion. Si el id ya no existe, cae al id. */
export const describeSelection = (
  selection: VisitSelection,
  stops: TiendaPerfectaVisitHistoryStop[]
): SelectionDescription | null => {
  if (!selection) return null;

  switch (selection.kind) {
    case 'day':
      return { kind: 'day', label: formatDate(selection.date) };
    case 'route': {
      const code = stops.find((s) => s.route.id === selection.routeId)?.route
        .code;

      return {
        kind: 'route',
        label: `${code ?? selection.routeId} · ${formatDate(selection.date)}`,
      };
    }
    case 'van':
      return {
        kind: 'van',
        label:
          stops.find((s) => s.van.id === selection.vanId)?.van.name ??
          selection.vanId,
      };
    case 'zone':
      return {
        kind: 'zone',
        label:
          stops.find((s) => s.zone.id === selection.zoneId)?.zone.name ??
          selection.zoneId,
      };
  }
};
